module.exports = __webpack_public_path__ + "img/cancel-active.bbaaa151.svg";